module.exports = __webpack_public_path__ + "img/0Q3B5909-12_H_Wood.a9463656.jpg";